import React from 'react';
import { Layout, Typography, Space } from 'antd';
import { GithubOutlined, WechatOutlined, QqOutlined } from '@ant-design/icons';
import './index.css';

const { Footer: AntFooter } = Layout;
const { Text, Link: AntLink } = Typography;

const AppFooter = () => {
  return (
    <AntFooter className="app-footer">
      <div className="footer-content">
        <Space>
          <Text>Copyright © 2025 我的博客. All Rights Reserved<br /></Text>
          <AntLink href="#" target="_blank" title="Github">
            <GithubOutlined style={{ fontSize: '24px', color: 'rgba(0, 0, 0, 0.65)' }} />
            <Text style={{ marginLeft: '4px' }}>Github</Text>
          </AntLink>

          <AntLink href="#" target="_blank" title="微信">
            <WechatOutlined style={{ fontSize: '24px', color: 'rgba(0, 0, 0, 0.65)'}} />
            <Text style={{ marginLeft: '4px' }}>Wechat</Text>
          </AntLink>

          <AntLink href="#" target="_blank" title="QQ">
            <QqOutlined style={{ fontSize: '24px', color: 'rgba(0, 0, 0, 0.65)'}} />
            <Text style={{ marginLeft: '4px' }}>QQ</Text>
          </AntLink>
        </Space>
        <Text style={{ display: 'block', marginTop: '10px' }}>
          Powered by React & Ant Design
        </Text>
      </div>
    </AntFooter>
  );
};

export default AppFooter;